import { render, staticRenderFns } from "./WatchParams.vue?vue&type=template&id=6a1440ba&scoped=true&"
import script from "./WatchParams.vue?vue&type=script&lang=js&"
export * from "./WatchParams.vue?vue&type=script&lang=js&"
import style0 from "./WatchParams.vue?vue&type=style&index=0&id=6a1440ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1440ba",
  null
  
)

export default component.exports